import { IPost } from '../../../../interfaces/post.interface';
import PostBody from './PostBody';
import PostFooter from './PostFooter';
import PostHead from './PostHead';
import PostDivWrapper from './component/PostDivWrapper';
import PostProvider from './provider/PostProvider';

const Post = ({
  groupMode = false,
  divWrapperClassName = '',
  ...postInfo
}: IPost & { groupMode?: boolean; divWrapperClassName?: string }) => {
  return (
    <PostDivWrapper widthClassname="" customClassname={divWrapperClassName}>
      <PostProvider postInfo={postInfo}>
        <div className="w-full rounded-[10px] bg-white px-2">
          <PostHead groupMode={groupMode} />
          <div className="px-2">
            <PostBody />
          </div>
          <PostFooter />
        </div>
      </PostProvider>
    </PostDivWrapper>
  );
};

export default Post;
